import { getCookie } from './cookies';

export function isNativeApp() {
  return getCookie('pp-native-app') != null;
}

export function getNativeAppCookieValue() {
  return getCookie('pp-native-app');
}
